// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Xq-z","imageAndVideoCount":"Yq-z","imageAndVideoContainer":"Zq-z","viewAllReviews":"_q-z"};